export default "__VITE_ASSET__db6a16e1__"